import Axios from "axios";
import { Toast } from "vant";
import Config from '../config/app.js'
import { getOpenId,getToken }  from '@/utils/app.js'
import {isAndroid} from '@/utils/isTerminal.js'

const service = Axios.create({
    baseURL: Config.apiUrl + "/" + Config.apiPrefix,
    headers: {
        Accept: "*/*"
    },
    timeout: Config.timeout
});

service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;

let LoadingInstance = null;

service.interceptors.request.use(
    config => {
        if (!config.closeLoading) {
            // console.log('123');
            LoadingInstance = Toast.loading({
                mask: true,
                duration: 0,
                message: "加载中..."
            });
        }

        config.headers["businessSource"] = 4;
        config.headers["terminalPlatform"] = isAndroid ? 3 : 2;
        config.headers["AccessModeEnum"] = 3;
        config.headers["requestId"] = new Date().getTime();
        config.headers["openId"] = getOpenId();
        config.headers["activity"] = 2;
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    res => {
        if (LoadingInstance) {
            LoadingInstance.clear();
        }

        if (res.status !== 200) {
            Toast("数据返回出错");
            return Promise.reject("error");
        } else {
            if (res.data.code === 100004) {
                //登录状态失效
                return;
            }
            if (res.data.code !== 100000) {
                if (res.config.closeInterceptors) {
                    return Promise.reject(res.data);
                }
                Toast(res.data.msg);
                return Promise.reject(res.data); // 完善为返回具体的错误信息 以便后续回调处理
            }
            return res.data.data;
        }
    },
    error => {
        if (LoadingInstance) {
            LoadingInstance.clear();
        }
        if (!error.closeNetworkError) {
            Toast("网络错误");
        }
        return Promise.reject(error);
    }
);

export default service;
